import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'
import { useFormContext } from 'react-hook-form'

import { sortAlphabeticallyByKey } from '@fortem-monorepo/js-utilities'
import { useApi } from '@fortem-monorepo/react-spa'
import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface GuarantorNameFieldProps {}

export const GuarantorNameField: React.FC<GuarantorNameFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ guarantor: string }>()

  const api = useApi()

  const guarantorQuery = useQuery({
    queryKey: ['misc', 'guarantors'],
    queryFn: () => api.misc.getGuarantors(),
  })

  const guarantors = useMemo(() => {
    return sortAlphabeticallyByKey(guarantorQuery.data ?? [], 'guarantor_name').map((g) => ({
      label: g.guarantor_name,
      value: g.guarantor_name,
    }))
  }, [guarantorQuery.data])

  return (
    <FormField
      name="guarantor"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Guarantor Name</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              value={value?.toString()}
              className={'flex flex-1 min-w-auto!'}
              placeholder={'Select a guarantor'}
              setValue={(value) => setValue('guarantor', value, { shouldValidate: true })}
              options={guarantors}
            />
          </FormItem>
        )
      }}
    />
  )
}
